import React from 'react';
const comparisonRows = [{
  situation: 'Cobro',
  without: 'Por clase, irregular',
  with: 'Abono mensual adelantado'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos y predecibles'
}, {
  situation: 'Nuevos alumnos',
  without: 'Solo boca a boca',
  with: 'Sistema de referidos activo'
}, {
  situation: 'Tu precio',
  without: 'El del mercado o menos',
  with: '30-50% más justificado'
}];
const blocks = [{
  icon: '💰',
  title: 'Sistema Financiero',
  desc: 'Del cobro por clase al abono mensual. Planilla + protocolo de cobranzas.'
}, {
  icon: '📊',
  title: 'Base de Datos 360°',
  desc: 'Ficha de cada alumno + onboarding de 30 días para retener.'
}, {
  icon: '📱',
  title: 'Marketing de Guerrilla',
  desc: 'Clase de diagnóstico + estrategia de redes + referidos.'
}, {
  icon: '📈',
  title: 'Retención y Escala',
  desc: 'De clases sueltas a membresía. Cómo delegar y escalar.'
}, {
  icon: '⚖️',
  title: 'Legal y Formal',
  desc: 'Reglamento + deslinde + contrato ético. Todo cubierto.'
}, {
  icon: '📅',
  title: 'Plan de 90 Días',
  desc: 'Implementación paso a paso. Todo instalado en 3 meses.'
}];
const assets = ['Planilla Financiera', 'Calculadora de Precio', 'Dashboard Semanal', 'Reglamento', 'Templates WhatsApp', 'Scripts Instagram', 'Plan Marketing 30 Días'];
export function EliteSection() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <div className="text-center mb-8" data-id="element-33">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-2" data-id="element-34">
            ¿Qué agrega la{' '}
            <span className="text-[#00B4D8]" data-id="element-35">Academia Pro™</span>?
          </h2>
          <p className="text-gray-400 text-sm sm:text-base max-w-lg mx-auto" data-id="element-36">
            Cobro, captación y negocio a la altura de tus clases.
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="space-y-2 mb-10" data-id="element-37">
          {comparisonRows.map(row => <div key={row.situation} className="bg-black/60 border border-[#00B4D8]/15 rounded-xl p-3 sm:p-4" data-id="element-38">
              <p className="text-white font-bold text-sm mb-2" data-id="element-39">
                {row.situation}
              </p>
              <div className="grid grid-cols-2 gap-3" data-id="element-40">
                <div className="flex items-start gap-1.5" data-id="element-41">
                  <span className="text-red-500 flex-shrink-0 text-xs mt-0.5" data-id="element-42">
                    ❌
                  </span>
                  <span className="text-gray-500 text-xs" data-id="element-43">{row.without}</span>
                </div>
                <div className="flex items-start gap-1.5" data-id="element-44">
                  <span className="text-[#00B4D8] flex-shrink-0 text-xs mt-0.5" data-id="element-45">
                    ✅
                  </span>
                  <span className="text-white text-xs" data-id="element-46">{row.with}</span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Modules */}
        <p className="text-gray-400 text-xs text-center mb-3" data-id="element-47">
          ✅ Academia Pro™ incluye:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-6 max-w-2xl mx-auto" data-id="element-48">
          {blocks.map(block => <div key={block.title} className="flex items-start gap-2 py-1" data-id="element-49">
              <span className="text-sm flex-shrink-0" data-id="element-50">{block.icon}</span>
              <p className="text-sm" data-id="element-51">
                <span className="text-white font-semibold" data-id="element-52">{block.title}</span>
                <span className="text-gray-500" data-id="element-53"> — {block.desc}</span>
              </p>
            </div>)}
        </div>

        {/* Assets inline */}
        <p className="text-center text-gray-500 text-xs" data-id="element-54">
          📊 Incluye: {assets.join(' · ')}
        </p>
      </div>
    </section>;
}